import { Box, Chip } from '@mui/material';

function splitCamelCaseAndCapitalize(str) {
  if (!str) return '';
  const withSpaces = str.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
  return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1);
}

// Recursive component to render rule conditions
function RuleConditions({ conditions, level = 0 }) {
  if (!conditions) return null;

  const renderConditionGroup = (group, groupType) => (
    <Box ml={level * 2}>
      {group.map((cond, idx) => (
        <Box
          key={cond.id || `${groupType}-${level}-${JSON.stringify(cond)}`}
          mb={1}
          flexDirection="row"
          display="flex"
          flexWrap="wrap"
          alignItems="center">
          {idx > 0 && (
            <Chip
              label={groupType === 'all' ? 'AND' : 'OR'}
              size="small"
              variant="outlined"
              sx={{ mr: 1, mb: 1 }}
            />
          )}
          {/* If sub-condition group exists, recurse */}
          {cond.any || cond.all ? (
            <RuleConditions conditions={cond} level={level + 1} />
          ) : (
            <>
              <Chip
                label={splitCamelCaseAndCapitalize(cond.fact)}
                size="small"
                color="primary"
                variant="outlined"
                sx={{ mr: 1, mb: 1 }}
              />
              <Chip
                label={splitCamelCaseAndCapitalize(cond.operator)}
                size="small"
                variant="outlined"
                sx={{ mr: 1, mb: 1 }}
              />
              {cond.path && (
                <Chip
                  label={cond.path}
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ mr: 1, mb: 1 }}
                />
              )}
              {cond.value && typeof cond.value !== 'object' && (
                <Chip
                  label={cond.value}
                  size="small"
                  color="primary"
                  variant="outlined"
                  sx={{ mr: 1, mb: 1 }}
                />
              )}
              {typeof cond.value === 'object' && cond.value && (
                <>
                  {cond.value.path && (
                    <Chip
                      label={cond.value.path}
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ mr: 1, mb: 1 }}
                    />
                  )}
                  {cond.value.operator && (
                    <Chip
                      label={splitCamelCaseAndCapitalize(cond.value.operator)}
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ mr: 1, mb: 1 }}
                    />
                  )}
                  {cond.value.value && (
                    <Chip
                      label={cond.value.value}
                      size="small"
                      color="primary"
                      variant="outlined"
                      sx={{ mr: 1, mb: 1 }}
                    />
                  )}
                </>
              )}
            </>
          )}
        </Box>
      ))}
    </Box>
  );

  if (conditions.all) {
    return renderConditionGroup(conditions.all, 'all');
  }
  if (conditions.any) {
    return renderConditionGroup(conditions.any, 'any');
  }
  return null;
}

export default RuleConditions;
